import { Component, EventEmitter, Output } from '@angular/core';
import { DateFilter } from '../local-types/DateFilter';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent {
  @Output() public selectionChanged = new EventEmitter<DateFilter>();
  public filter: DateFilter = { date: this.getCurrentDate(), isEqualTo: false, isGreaterThan: false, isLessThan: false };

  public hasFilterSelected(): boolean {
    return this.filter && this.filter.date && (this.filter.isEqualTo || this.filter.isGreaterThan || this.filter.isLessThan);
  }

  public invokeSelectionChanged(): void {
    this.selectionChanged.emit(this.filter);
  }

  public clearFilters(): void {
    this.filter = { date: this.getCurrentDate(), isEqualTo: false, isGreaterThan: false, isLessThan: false };
    this.invokeSelectionChanged();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public dateChanged(event: any): void {
    if (event && event.value) {
      this.filter.date = new Date(event.value);
      this.invokeSelectionChanged();
    }
  }

  private getCurrentDate(): Date {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
}
